var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ies-form-field",
    { attrs: { field: _vm.field } },
    [
      _vm.viewValue !== "Other..."
        ? _c("v-autocomplete", {
            attrs: {
              "hide-details": "",
              dense: "",
              outlined: "",
              items: [
                ...new Set(_vm.items.concat(_vm.viewValue).filter(Boolean)),
                "Other...",
              ],
              autocomplete: "",
            },
            model: {
              value: _vm.viewValue,
              callback: function ($$v) {
                _vm.viewValue = $$v
              },
              expression: "viewValue",
            },
          })
        : _c("v-text-field", {
            attrs: {
              "hide-details": "",
              "validate-on": "eager",
              rules: [
                (v) =>
                  "Other..." === v ||
                  "Fill in this field, and press Enter when done, or press Esc to cancel",
              ],
              autofocus: "",
              required: "",
            },
            on: {
              focus: function ($event) {
                ;[(_vm.newValue = "")]
              },
              keyup: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  _vm.viewValue = _vm.newValue
                },
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape",
                    ])
                  )
                    return null
                  _vm.viewValue = null
                },
              ],
            },
            model: {
              value: _vm.newValue,
              callback: function ($$v) {
                _vm.newValue = $$v
              },
              expression: "newValue",
            },
          }),
      _vm._v(" "),
      _c("input", {
        attrs: {
          type: "hidden",
          name: _vm.field.fieldName,
          text: _vm.field.text,
        },
        domProps: { value: _vm.field.value },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }